export const getAvailableGroups = (userGroups, selectedGroupId) => {
  return userGroups
    ?.filter(group => !group?.default && group.id !== selectedGroupId)
    .map(group => ({ label: group.name, value: group.id }))
}

export const hasElegibleGroups = userGroups => {
  return userGroups?.some(group => !group?.default)
}
